import { render, staticRenderFns } from "./DownloadWillLoadingPage.vue?vue&type=template&id=949ce684"
import script from "./DownloadWillLoadingPage.vue?vue&type=script&lang=js"
export * from "./DownloadWillLoadingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports